"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var clickOutside_1 = require("../clickOutside");
var cross_1 = require("../icons/cross");
var text_1 = require("../base/text");
var react_transition_group_1 = require("react-transition-group");
var functions_1 = require("../../utils/functions");
exports.Modal = function (_a) {
    var children = _a.children, show = _a.show, header = _a.header, contentClassName = _a.contentClassName, _b = _a.onClose, onClose = _b === void 0 ? functions_1.NOOP : _b, _c = _a.closeOnOutsideClick, closeOnOutsideClick = _c === void 0 ? true : _c;
    var _d = React.useState(show), modalOn = _d[0], setModalOn = _d[1];
    var modalClassName = classnames_1.default('ty-modal', 'ty-bordered');
    var modalContentClassName = classnames_1.default('ty-modal-content', 'ty-relative', contentClassName);
    React.useEffect(function () {
        if (show) {
            document.body.classList.add('ty-scroll-disabled-body');
        }
        else {
            document.body.classList.remove('ty-scroll-disabled-body');
        }
        setModalOn(show);
    }, [show]);
    var getHeader = function () {
        return (header && (React.createElement(styledLayout_1.StyledLayout, { className: "ty-modal-header" },
            React.createElement(text_1.Text, { fontSize: "ty-font-lg" /* Large */ }, header))));
    };
    return (React.createElement(react_transition_group_1.CSSTransition, { classNames: "ty-transition-appear", timeout: 300, in: modalOn, onExited: onClose, unmountOnExit: true },
        React.createElement(styledLayout_1.StyledLayout, { className: modalClassName, display: "ty-display-flex" /* Flex */ },
            React.createElement(clickOutside_1.ClickOutside, { className: modalContentClassName, condition: closeOnOutsideClick && modalOn, onClickOutside: function () { return setModalOn(false); } },
                React.createElement("a", { onClick: function () { return setModalOn(false); } },
                    React.createElement(cross_1.Cross, { size: "small" /* Small */ })),
                getHeader(),
                children))));
};
